import { SHAPES } from './constants';
import { getRandomInRange } from './utils';

export class Shape {
  constructor(x, y, size, color, type, speed = 2.0) {
    this.x = x;
    this.y = y;
    this.size = size * 0.9;
    this.color = color;
    this.type = type;
    this.alpha = 1;
    this.speed = speed;
    this.rotation = Math.random() * Math.PI * 2;
    this.rotationSpeed = getRandomInRange(0.01, 0.05);
    
    // 残像の設定
    this.trailPositions = [];
    this.trailMaxLength = 12; // PCでは長めの残像
    this.trailUpdateCounter = 0;
    this.trailUpdateInterval = 2; // 更新間隔を調整
    
    if (type === SHAPES.LINE) {
      const angle = Math.random() * Math.PI;
      const canvasWidth = window.innerWidth;
      const canvasHeight = window.innerHeight;
      
      let startX, startY, endX, endY;
      
      if (Math.abs(Math.tan(angle)) <= canvasHeight/canvasWidth) {
        startX = -canvasWidth * 0.2;
        startY = y - (x * Math.tan(angle));
        endX = canvasWidth * 1.2;
        endY = y + ((canvasWidth - x) * Math.tan(angle));
      } else {
        startX = x - (y / Math.tan(angle));
        startY = -canvasHeight * 0.2;
        endX = x + ((canvasHeight - y) / Math.tan(angle));
        endY = canvasHeight * 1.2;
      }
      
      this.startX = startX;
      this.startY = startY;
      this.endX = endX;
      this.endY = endY;
    }
    
    this.lifespan = getRandomInRange(20, 40);
    this.age = 0;
    this.minAlpha = 0.01;
  }

  update() {
    this.age++;
    
    // 初期サイズの2倍まで拡大
    const maxSize = this.size * 2;
    
    // サイズの増加量を調整
    const sizeIncrease = this.speed * 2.0;
    
    // サイズの制限
    if (this.size < maxSize) {
      this.size += sizeIncrease;
    }
    
    // 残像の更新
    this.trailUpdateCounter++;
    if (this.trailUpdateCounter >= this.trailUpdateInterval) {
      this.trailPositions.push({
        x: this.x,
        y: this.y,
        size: this.size,
        rotation: this.rotation
      });
      this.trailUpdateCounter = 0;
    }
    
    if (this.trailPositions.length > this.trailMaxLength) {
      this.trailPositions.shift();
    }
    
    this.rotation += this.rotationSpeed;
    
    const progress = this.age / this.lifespan;
    this.alpha = Math.max(this.minAlpha, 1 - progress * 0.7);
    
    return this.alpha > this.minAlpha;
  }

  drawShape(ctx, x, y, size, rotation, alpha) {
    if (alpha < 0.1) return; // 透明度が低いものは描画しない
    
    ctx.globalAlpha = alpha;
    ctx.strokeStyle = this.color;
    ctx.lineWidth = Math.max(1, size / 20);

    switch(this.type) {
      case SHAPES.CIRCLE:
        ctx.beginPath();
        ctx.arc(x, y, size, 0, Math.PI * 2);
        ctx.stroke();
        break;
      
      case SHAPES.SQUARE:
        ctx.save();
        ctx.translate(x, y);
        ctx.rotate(rotation);
        ctx.beginPath();
        ctx.rect(-size / 2, -size / 2, size, size);
        ctx.stroke();
        ctx.restore();
        break;
      
      case SHAPES.TRIANGLE:
        ctx.beginPath();
        ctx.save();
        ctx.translate(x, y);
        ctx.rotate(rotation);
        const height = size * Math.sqrt(3) / 2;
        ctx.moveTo(0, -height / 2);
        ctx.lineTo(-size / 2, height / 2);
        ctx.lineTo(size / 2, height / 2);
        ctx.closePath();
        ctx.stroke();
        ctx.restore();
        break;
      
      case SHAPES.LINE:
        ctx.beginPath();
        ctx.moveTo(this.startX, this.startY);
        ctx.lineTo(this.endX, this.endY);
        ctx.stroke();
        break;
      
      default:
        console.error('不明な形状タイプ:', this.type);
        break;
    }
  }

  draw(ctx) {
    // 残像の描画
    for (let i = 0; i < this.trailPositions.length; i++) {
      const pos = this.trailPositions[i];
      const trailAlpha = this.alpha * (i / this.trailPositions.length) * 0.5; // 透明度を調整
      if (trailAlpha > 0.1) {
        this.drawShape(ctx, pos.x, pos.y, pos.size, pos.rotation, trailAlpha);
      }
    }
    
    this.drawShape(ctx, this.x, this.y, this.size, this.rotation, this.alpha);
    
    ctx.globalAlpha = 1;
  }
}